import Bugsnag from '@bugsnag/js';

export const TrackError = e => {
  if (!window.location.href.includes('localhost')) {
    console.log('BUGSNAG', e);
    Bugsnag.notify(e);
  }
};
